angular.module('unergie.main')
.factory('PotService', (DataAccess, AlertManager, AccountService, AdminComments, MetaWatcher, ErrorCatcher) => {
    let pot = {}

    const getPot = function (id, callback) {
        pot = {}
        return DataAccess.potBalance({ id_account: id }).$promise.then((balance) => {
            pot.balance = balance
            return DataAccess.potHistory({ id_account: id }).$promise.then((history) => {
                pot.history = history
                return callback(null, pot)
            })
        }).catch((err) => {
            ErrorCatcher(err)
            return callback(err)
        })
    }

    return {
        getPot,
    }
})
